export const pageConstant = {
  PAGE_REQUEST: "PAGE_REQUEST",
  PAGE_SUCCESS: "PAGE_SUCCESS",
  PAGE_FAILURE: "PAGE_FAILURE",
};